import { useContext } from 'react'
import { InstallationOnlineStatusContext } from 'src/Libs/installations/context/installation-online-status-context'
import { useTypedSelector } from 'src/State/RootReducer'
import { isTariffRedirectDisabled } from '../utils/is-tariff-redirect-disabled'

export const useIsTariffRedirectDisabled = (): boolean => {
  const activeStorage = useTypedSelector(state => state.storage.activeStorage)
  const { isStorageOnline } = useContext(InstallationOnlineStatusContext)

  return isTariffRedirectDisabled(activeStorage, isStorageOnline)
}
